module.exports = {"next":"Siguiente &raquo;","previous":"&laquo; Anterior"};